import PaymentListTable from "./table";

const PaymentList = () => {
  return <PaymentListTable />;
};

export default PaymentList;
